import { StatusCode } from 'grpc-web'
import { Id } from 'types/definitions'
import { GetTxfJobRequest } from '@taxfyle/api-internal/internal/txf_pb'
import { WorkAPI } from './API'
import { collection } from '../infra/collection'
import { mapTxfJobProtoToDTO, TxfJobDTO } from './dtos/txf-job'
import TxfJob from './TxfJob'

export default class TxfJobStore {
  /**
   * TxfJobs collection.
   */
  txfJobs = collection<TxfJobDTO, TxfJob>({
    create: () => new TxfJob(),
    idAttribute: 'job_id',
  })

  constructor(private api: WorkAPI) {}

  forJob = (jobId: Id) => this.txfJobs.get(Id.assert(jobId))

  async fetchTxfJob(jobId: Id) {
    const request = new GetTxfJobRequest().setJobId(Id.assert(jobId))

    return this.api.txf
      .getTxfJob(request)
      .then((response) => mapTxfJobProtoToDTO(response))
      .then((txfJob) => this.txfJobs.set(txfJob))
      .catch((e) => {
        if (e.code === StatusCode.NOT_FOUND) {
          return undefined
        }

        throw e
      })
  }
}
